import { connect } from 'react-redux'
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'

import { closeModalStudent } from '../../../actions/purchaseActions'
import { formatURL } from '../../../utils';

export class ModalStudent extends Component {
    constructor(props) {
        super(props)

        this.goToSearchPage = this.goToSearchPage.bind(this);
    }

    goToSearchPage() {
        const location = {
            pathname: formatURL(
                this.props.match.params,
                `/pesquisa/${this.props.match.params.destination}/${this.props.match.params.begin_date}/${this.props.match.params.end_date}/`,
                '',
                true,
            ),
            search: window.location.search,
        }

        this.props.history.push(location);
    }

    render() {
        if (!this.props.isModalStudentActive)
            return <div />

        return (

            <div className="comp_modalpagamento quotationDateWarning-modal franchise-modal">
                <div className="modalcontents">
                    <div className="contents">

                        <div className="modaltop">
                            <div className="title center">Confirma o seguro viagem com finalidade estudantil? </div>
                            <div onClick={this.props.closeModalStudent} className="close-btn" > &times; </div>
                        </div>
                        <div className="modalmiddle" style={{ margin: '10px 40px 30px 40px' }}>
                            <p>Este seguro viagem só tem cobertura pra quem vai estudar. Se for o seu caso aproveite a economia, se não for escolha outro seguro viagem. Na dúvida entre em contato conosco!</p>
                        </div>

                        <div className="choosecontainer">
                            <div className="optionone">
                                <button className="button" onClick={this.goToSearchPage}>
                                    <span>Voltar à pesquisa</span>
                                </button>
                            </div>
                        </div>
                        <div className="choosecontainer continue">
                            <div className="optionone">
                                <button className="button" onClick={this.props.closeModalStudent}>
                                    <span>Continuar</span>
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}

export default connect(
    state => ({
        benefits: state.purchase.benefits_list,
        rawProductCoverage: state.coverage.rawProductCoverage,
        isModalStudentActive: state.purchase.isModalStudentActive,
    }),
    {
        closeModalStudent
    }
)(withRouter(ModalStudent));



// WEBPACK FOOTER //
// ./src/components/purchase/modal_student/ModalStudent.jsx